module.exports = __webpack_public_path__ + "../../static/vue/img/omega_512.b63ff005.jpg";